export default "__VITE_ASSET__C2TYU8oy__"